import { commonCrudOption } from '@/const/crud/commonOption'
import { getToken } from '@/utils/auth'

export const getTableOption = () => ({
  ...commonCrudOption,
  // delBtn: true,
  editBtn: false,
  // addBtn: true,
  menuWidth: 120,
  labelWidth: 180,
  searchIndex: 2,
  searchLabelWidth: 100,
  searchMenuSpan: 4,
  column: [
    {
      label: '科目编码',
      prop: 'code',
      hide: true,

      order: 130,
      display: true,
      editDisabled: true,
      rules: [
        { required: true, message: '请输入收费科目编码', trigger: 'blur' }
      ]
    },
    {
      label: '科目名称',
      prop: 'name',
      minWidth: 150,
      overHidden: true,
      search: true,
      placeholder: '科目名称',

      display: true,
      order: 120,
      rules: [
        { required: true, message: '请输入收费科目名称', trigger: 'blur' }
      ]
    },
    {
      label: '科目类型',
      prop: 'pid',
      overHidden: true,
      width: '120',

      display: true,
      showCheckbox: true,
      checkStrictly: true,
      order: 110,
      type: 'tree',
      dicUrl: process.env.VUE_APP_BASE_API + '/api/finance/account/type/tree?includeValid=true',
      dicHeaders: {
        Authorization: getToken()
      },
      props: {
        children: 'children',
        label: 'name',
        value: 'id'
      },
      rules: [
        { required: true, message: '请选择收费科目类型', trigger: 'blur' }
      ]
    },
    {
      label: '状态',
      prop: 'enabled',
      overHidden: true,
      width: '60',
      search: true,
      searchLabel: '是否封存',
      placeholder: ' ',
      display: true,
      value: 0,
      order: 100,
      type: 'radio',
      dicData: [
        { label: '正常', value: 1 },
        { label: '封存', value: 0 }
      ],
      rules: [
        { required: true, message: '请选择是否封存', trigger: 'blur' }
      ]
    },
    {
      label: '房态折扣',
      prop: 'enableStatusDisaccount',
      overHidden: true,
      search: true,
      placeholder: ' ',
      width: '110',

      type: 'radio',
      dicData: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      value: 0,
      display: true,
      order: 99,
      rules: [
        { required: true, message: '请选择是否房态折扣', trigger: 'blur' }
      ]
    },

    {
      label: '收取违约金',
      prop: 'enableLatefee',
      overHidden: true,
      search: true,
      placeholder: ' ',
      type: 'radio',
      width: '110',
      dicData: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],

      display: true,
      value: 0,
      order: 80,
      rules: [
        { required: true, message: '请选择是否收取违约金', trigger: 'blur' }
      ],
      control: (val, form) => {
        if (val == 0) {
          return {
            latefeeChargeRatio: {
              display: false
            },
            latefeeCalculateType: {
              display: false
            }
          }
        } else {
          return {
            latefeeChargeRatio: {
              display: true
            },
            latefeeCalculateType: {
              display: true
            }
          }
        }
      }
    },
    {
      label: '违约金比例(%)',
      prop: 'latefeeChargeRatio',
      overHidden: true,
      width: '130',

      type: 'number',
      precision: 2,
      controls: false,
      min: 0,
      display: true,
      order: 79,
      rules: [
        { required: true, message: '请输入违约金比例', trigger: 'blur' }
      ]
    },
    {
      label: '违约金规则',
      prop: 'latefeeCalculateType',
      overHidden: true,
      formslot: true,
      width: '130',
      formatter: (val, value) => {
        const { latefeeCalculateType, latefeeCalculateValue, latefeeCalculateValue1, latefeeCalculateValue2 } = val || {}
        if (latefeeCalculateType === 'A') {
          return `按${latefeeCalculateValue}天之后`
        } else if (latefeeCalculateType === 'B') {
          return `推迟${latefeeCalculateValue1}月${latefeeCalculateValue2}号开始`
        }
      },
      display: true,
      order: 60,
      rules: [
        { required: true, message: '请输入违约金比例', trigger: 'blur' }
      ]
    },

    {
      label: '启用发票',
      prop: 'enableInvoice',
      overHidden: true,
      width: '90',
      search: true,
      placeholder: ' ',

      display: true,
      type: 'radio',
      dicData: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      value: 0,
      order: 95,
      rules: [
        { required: true, message: '请选择是否支持开票', trigger: 'blur' }
      ],
      control: (val, form) => {
        if (val == 0) {
          return {
            invoiceGoodCode: {
              display: false
            },
            invoiceGoodName: {
              display: false
            },
            invoiceTaxRate: {
              display: false
            }
          }
        } else {
          return {
            invoiceGoodCode: {
              display: true
            },
            invoiceGoodName: {
              display: true
            },
            invoiceTaxRate: {
              display: true
            }
          }
        }
      }
    },
    {
      label: '发票商品编码',
      prop: 'invoiceGoodCode',
      overHidden: true,
      width: '160',

      display: true,
      order: 93,
      rules: [
        { required: true, message: '请输入商品或服务编码', trigger: 'blur' }
      ]
    },
    {
      label: '发票商品名称',
      prop: 'invoiceGoodName',
      overHidden: true,
      width: '160',

      display: true,
      order: 92,
      rules: [
        { required: true, message: '请输入发票商品名称', trigger: 'blur' }
      ]
    },
    {
      label: '发票税率(%)',
      prop: 'invoiceTaxRate',
      overHidden: true,
      width: '120',

      display: true,
      type: 'number',
      controls: false,
      precision: 2,
      order: 94,
      min: 0,
      rules: [
        { required: true, message: '请输入税率', trigger: 'blur' }
      ]
    },
    {
      label: '说明',
      prop: 'memo',
      hide: true,

      type: 'textarea',
      rows: 3,
      display: true,
      order: 10
    }
  ]
})
